import React, { useContext } from 'react'
import { NavLink, useHistory } from 'react-router-dom'
import logo from '../images/tshirt-front.png'
import fire from '../auth/fire'
import { AuthContext } from '../auth/auth'
import { store } from 'react-notifications-component'
import "react-notifications-component/dist/theme.css";
const Navbar = () => {
    const { currentUser } = useContext(AuthContext);
    const history = useHistory();

    const notifyPopup = () => {
        store.addNotification({
            title: "Logged Out!",
            message: "You are Logged Out!",
            type: "danger",
            background: "pink",
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 3000,
                onScreen: true,
            },
        });
    };
    const logout = () => {
        fire.auth().signOut().then(
            notifyPopup(),
            history.push('/')
        );
    }
    return (
        <>
            <nav className="container-fluid bg-white shadow-sm sticky-top ">
                <div className="row">
                    <div className="mx-auto col-10 text-center">
                        <nav className="navbar navbar-expand-lg navbar-light ">
                            <img src={logo} alt='careergrads' style={{ width: '50px', height: '50px', cursor: 'pointer' }} />
                            <NavLink
                                className="navbar-brand" to="/"><strong><span className="text-primary">C</span>areer<span className="text-primary">G</span>rads</strong></NavLink>
                            <button className="navbar-toggler" type="button" data-toggle="collapse"
                                data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                                aria-expanded="false" aria-label="Toggle navigation">
                                <span className="navbar-toggler-icon"></span>
                            </button>
                            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                <div className="navbar-nav mx-auto">
                                    <NavLink activeClassName='menu_active text-primary' exact
                                        className="nav-item nav-link" to="/">Home</NavLink>
                                    <div className="dropdown">    {/* Drop Down */}
                                        <button className="btn nav-item dropdown-toggle text-black-50" activeClassName="text-dark menu_active" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                            Courses
                                        </button>
                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1" >
                                            <li><NavLink to='/services' activeClassName="bg-secondary text-white" className="dropdown-item text-decoration-none" href="#">Schooling</NavLink></li>
                                            <li><NavLink to='/professional' activeClassName="bg-secondary text-white" className="dropdown-item text-decoration-none" href="#">Professional</NavLink></li>
                                        </ul>
                                    </div>
                                    <NavLink activeClassName='menu_active text-primary'
                                        className="nav-item nav-link" to="/about">About</NavLink>
                                    <NavLink activeClassName='menu_active text-primary'
                                        className="nav-item nav-link " to="/market-place">MarketPlace</NavLink>
                                    <NavLink activeClassName='menu_active text-primary'
                                        className="nav-item nav-link " to="/contact">Contact Us</NavLink>
                                </div>
                                <div className="text-black">
                                    {currentUser ? (
                                        <div className="dropdown open" style={{ outline: "none", border: "none" }}>
                                            <button className="btn dropdown-toggle " type="button" id="triggerId" data-toggle="dropdown" aria-haspopup="true"
                                                aria-expanded="false">
                                                <img src="https://img.icons8.com/officel/30/000000/lock-2.png" style={{ width: "24px" }} />
                                                {currentUser.email}
                                            </button>
                                            <div className="dropdown-menu" aria-labelledby="triggerId">
                                                <NavLink className="dropdown-item" activeClassName="dropdown-item menu_active" to="/profile">Profile</NavLink>
                                                <button className="dropdown-item btn rounded bg-gradient" onClick={logout}>Logout</button>
                                            </div>
                                        </div>
                                    ) : (
                                        <NavLink activeClassName='menu_active text-black' exact
                                            to="/login" className="nav-item nav-link text-black ">Login / SignUp</NavLink>

                                    )}
                                </div>
                            </div>
                        </nav>
                    </div>
                </div>
            </nav>

        </>
    )
}

export default Navbar
